<div class="d-flex align-items-start border rounded p-2 mb-3">
  <i class="fas fa-info-circle text-muted me-2"></i>
  <span class="small text-muted">
    {{ 'Settings::AnalyticsFeatures:RestrictedFeaturesInfoBanner' | abpLocalization }}
  </span>
</div>

<form [formGroup]="form" (ngSubmit)="onSubmitForm()">
    <div class="form-group pt-2">
    <input type="checkbox" id="genderEnabled" formControlName="genderEnabled" />
    <label class="ps-1" for="genderEnabled">
      {{ 'Settings::AnalyticsFeatures:Gender.Enabled' | abpLocalization }}
      <span class="badge bg-light text-muted border small fw-normal ms-2">
        {{ 'Settings::AnalyticsFeatures:ConsentRequiredBadge' | abpLocalization }}
      </span>
    </label>
  </div><div class="form-group pt-2">
    <input type="checkbox" id="emotionEnabled" formControlName="emotionEnabled" />

    <label class="ps-1" for="emotionEnabled">
      {{ 'Settings::AnalyticsFeatures:Emotion.Enabled' | abpLocalization }}
      <span class="badge bg-light text-muted border small fw-normal ms-2">
        {{ 'Settings::AnalyticsFeatures:ConsentRequiredBadge' | abpLocalization }}
      </span>
    </label>
  </div><div class="form-group pt-2">
    <input type="checkbox" id="sentimentEnabled" formControlName="sentimentEnabled" />
    <label class="ps-1" for="sentimentEnabled">
      {{ 'Settings::AnalyticsFeatures:Sentiment.Enabled' | abpLocalization }}
      <span class="badge bg-light text-muted border small fw-normal ms-2">
        {{ 'Settings::AnalyticsFeatures:ConsentRequiredBadge' | abpLocalization }}
      </span>
    </label>
  </div><div class="form-group pt-2">
    <input type="checkbox" id="textCorrectionEnabled" formControlName="textCorrectionEnabled" />
    <label class="ps-1" for="textCorrectionEnabled">
      {{ 'Settings::AnalyticsFeatures:TextCorrection.Enabled' | abpLocalization }}
    </label>
  </div><div class="form-group pt-2">
    <input type="checkbox" id="acousticEnabled" formControlName="acousticEnabled" />
    <label class="ps-1" for="acousticEnabled">
      {{ 'Settings::AnalyticsFeatures:Acoustic.Enabled' | abpLocalization }}
      <span class="badge bg-light text-muted border small fw-normal ms-2">
        {{ 'Settings::AnalyticsFeatures:ConsentRequiredBadge' | abpLocalization }}
      </span>
    </label>
  </div>
  <button type="button" type="submit" class="btn btn-primary mt-3">
    <i class="me-1 fas fa-save"></i>
    {{ 'AbpUi::Save' | abpLocalization }}
  </button>
</form>

<ng-template #restrictedFeatureConfirmModal let-modal>
  <div class="modal-body">
    <div class="d-flex align-items-start">
      <i class="fas fa-exclamation-triangle text-warning fs-4 me-2"></i>
      <div>
        <div class="fw-bold">
          {{ 'Settings::AnalyticsFeatures:RestrictedFeatureConfirmTitle' | abpLocalization }}
        </div>
      </div>
    </div>

    <div class="mt-2">
      {{ 'Settings::AnalyticsFeatures:RestrictedFeatureConfirmEnableList' | abpLocalization }}
      <strong>{{ pendingRestrictedFeatureNamesLabel }}</strong>
    </div>

    <p class="mt-3">
      {{ 'Settings::AnalyticsFeatures:RestrictedFeatureConfirmBody' | abpLocalization }}
    </p>

    <ul class="mb-0">
      <li>{{ 'Settings::AnalyticsFeatures:RestrictedFeatureConfirmBulletLegalBasis' | abpLocalization }}</li>
      <li>{{ 'Settings::AnalyticsFeatures:RestrictedFeatureConfirmBulletInformCustomers' | abpLocalization }}</li>
      <li>{{ 'Settings::AnalyticsFeatures:RestrictedFeatureConfirmBulletAuditLog' | abpLocalization }}</li>
    </ul>

    <div class="border rounded p-3 mt-3">
      <div class="form-check mb-0">
        <input
          type="checkbox"
          class="form-check-input"
          id="restrictedFeatureConfirmCheckbox"
          [checked]="confirmModalChecked"
          (change)="onConfirmCheckboxChange($event)"
        />
        <label class="form-check-label" for="restrictedFeatureConfirmCheckbox">
          {{ 'Settings::AnalyticsFeatures:ConsentConfirmationText' | abpLocalization }}
        </label>
      </div>
    </div>
  </div>
  <div class="modal-footer border-0">
    <button type="button" class="btn btn-light" (click)="modal.dismiss()">
      {{ 'Settings::AnalyticsFeatures:RestrictedFeatureConfirmCancel' | abpLocalization }}
    </button>
    <button
      type="button"
      class="btn btn-primary"
      [disabled]="!confirmModalChecked"
      (click)="modal.close('confirm')"
    >
      {{ 'Settings::AnalyticsFeatures:RestrictedFeatureConfirmEnable' | abpLocalization }}
    </button>
  </div>
</ng-template>